jQuery(function () {
  var $container = jQuery('<div id="unobtrusive-flash-messages"></div>');
  jQuery("article .content").first().prepend($container);

  // BEHAVIOUR

  function hideFlash($flash) {
    $flash.slideUp(100, function () {
      $flash.remove();
    });
  }

  // EVENT HANDLERS

  function flashHandler(e, params) {
    var $flashMessageWrapper = jQuery(
      '<div class="flash unobtrusive-flash-message-wrapper unobtrusive-flash-"' + params.type + '"></div>',
    );

    if (params.type == "broadcast_messages") {
      setBroadcastMessages($flashMessageWrapper, params);
    } else {
      setErrorMessage($flashMessageWrapper, params);
    }
  }

  // HELPER FUNCTIONS

  function setBroadcastMessages($flashMessageWrapper, params) {
    var broadcastParams = params.message.split("#");
    var controller = broadcastParams[0];
    var action = broadcastParams[1];

    jQuery.ajax({
      url: "/broadcast_messages",
      data: { api: "error_flash", controller_name: controller, controller_action: action },
      type: "GET",
      success: function (data) {
        setFlashMessage($flashMessageWrapper, data);
      },
    });
  }

  function setErrorMessage($flashMessageWrapper, params) {
    $flashMessageWrapper.addClass("error");
    setFlashMessage($flashMessageWrapper, '<div class="unobtrusive-flash-message">' + params.message + "</div>");

    $flashMessageWrapper.hide().delay(300).slideDown(100);

    // EVENT HANDLERS
    $flashMessageWrapper.on("click", function () {
      hideFlash($flashMessageWrapper);
    });
  }

  function setFlashMessage($flashMessageWrapper, message) {
    $flashMessageWrapper.html(message);
    $container.prepend($flashMessageWrapper);
  }

  // INITIALIZE

  jQuery(window).on("rails:flash", flashHandler);
});
